export * from "./last-searches.module";
export * from "./last-searches.service";
export * from "./last-searches.types";
